module.exports = __webpack_public_path__ + "img/balloons.0b6cbf54.svg";